import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class BigdesImplementationProcessEvaluationService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data || [],
                pagination: response.pagination || {},
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch implementation process evaluations');
        }
    }

    async update(id, payload) {
        try {
            const response = await withRetry(() => this.api.update(id, payload), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update implementation process evaluation');
        }
    }

    _handleError(error, fallbackMessage) {
        if (error instanceof ApiError) return error;
        return new ApiError(fallbackMessage, error?.response?.status || 500, error?.response?.data);
    }
}
